import axios from 'axios';

// API Base URL is determined dynamically:
// - Dev with tenant domain (e.g. acme.irhba.ir:3000): http://{hostname}:5001/api
// - Dev fallback (localhost:3000): REACT_APP_API_URL from env
// - Production: /api (same origin, Caddy reverse_proxy handles routing)
const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const isDev = process.env.NODE_ENV === 'development';
const isTenantDomain = isDev && hostname !== 'localhost' && hostname !== '127.0.0.1';

export const API_BASE_URL = isTenantDomain
  ? `http://${hostname}:5001/api`
  : (process.env.REACT_APP_API_URL || '/api');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token and fix FormData for mobile
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // برای FormData: Content-Type را حذف کن تا مرورگر boundary را درست تنظیم کند (مهم برای موبایل)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    console.error('❌ API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorMessage = error.response?.data?.message || error.message;
    const status = error.response?.status;
    const url = error.config?.url;
    
    // Don't log 404 errors - they are valid "not found" responses
    if (status !== 404) {
      console.error(`❌ API Error ${status}: ${url} - ${errorMessage}`);
    }
    
    // برای 401 فقط وقتی redirect کنیم که درخواست login نبوده (مثلاً token منقضی شده)
    const isLoginRequest = url?.includes('/auth/login');
    if (status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
export { api };

